import debounce from 'lodash/debounce'
import reduce from 'lodash/reduce'
import { useEffect, useMemo, useState } from 'react'

export function useDebouncedLoading(
  delayMs: number,
  flags: ReadonlyArray<boolean>
) {
  const isLoading = reduce(
    flags,
    (flagOne, flagTwo) => flagOne || flagTwo,
    false
  )
  const [loading, _setLoading] = useState<boolean>(false)
  const setLoading = useMemo(() => debounce(_setLoading, delayMs), [delayMs])
  useEffect(() => setLoading(isLoading), [setLoading, isLoading])
  return loading
}
